import WhDocument from "../../../../services/wh-document.service";
import {mapGetters} from "vuex";

export const Incomes = {
	data() {
		return {
			incomes: {
				sidebar: false,
				items: [],
				fields: [],
				loader: false,
				total: 0,
				search: {
					page: 1,
					limit: 20,
					attributes: []
				}
			}
		}
	},

	methods: {
		loadIncomes() {
      this.incomes.loader = true;
      const params = Object.assign({}, this.incomes.search);
      WhDocument.search2(params).then(response => {
        this.incomes.items = response.data.items;
        this.incomes.total = response.data.total;
        this.incomes.loader = false;
        this.incomes.search.attributes = [];
      }).catch((error) => {
        this.incomes.loader = false;
        const err = JSON.parse(error.request.response);
        this.$vs.notify({
          title: this.$t('words.error'),
          text: err.message,
          color: 'danger',
          icon: 'close',
          position: 'top-right'
        });
      });
    },
		filterColumns(columns = []) {
			return columns.filter(column => {
				if (column.visible) {
					column.label = this.$t(column.label);
					// if (column.class === 'table_actions min-60 fixed-col') {
					// 	column.class = 'table_actions min-60';
					// }
					return column
				}
			})
		},
		incomeFiltered($event) {
			this.incomes.search.attributes = $event.attr;
			this.loadIncomes();
		}
	},

	computed: {
		...mapGetters('warehouse', [
			'columnsIncome'
		]),
	},

	created() {
		this.loadIncomes();
		this.incomes.fields = this.filterColumns(this.columnsIncome);
	}
};
